<template>
  <div>
    <!-- begin breadcrumb -->
    <ol class="breadcrumb float-xl-right">
      <li class="breadcrumb-item active">
        <a href="javascript:;">Personal</a>
      </li>
    </ol>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">Módulo Personal </h1>
    <!-- end page-header -->
    <!-- begin panel -->
    <!-- <panel title="Panel Title here">
			Panel Content Here
		</panel> -->
    <!-- end panel -->
    <!-- begin card -->
    <div class="card border-0">
      <div class="card-body">
        <button
          v-show="nuevoPersonal == 0"
          type="button"
          class="btn btn-warning"
          @click="
            nuevoPersonal = 1;
			generarExcel =0;
            nuevo = true;
          "
        >
          <i class="fa fa-plus"></i> Nuevo Personal
        </button>
        &nbsp;
        <button
          v-show="nuevoPersonal == 1"
          type="button"
          class="btn btn-danger animated fadeIn"
          @click="nuevoPersonal = 0"
        >
          <i class="fa fa-list"></i> Ver Personal
        </button>

        <button
          v-show="nuevoPersonal == 0 && (generarExcel == 0 || generarExcel == 1)"
          @click="descargarExcel();"
          type="button"
          class="btn btn-danger"
        >
          <i class="fa fa-download"></i>
          {{
            generarExcel == 0
              ? "Generar Excel"
              : generarExcel == 1
              ? "Generando..."
              : ""
          }}
        </button>
        <export-excel
          v-show="nuevoPersonal == 0 && generarExcel == 2 "
          class="btn btn-success"
          :footer="'TOTAL DE REGISTROS: ' + json_data.length"
          title="::..SISTEMA TELEMARTIN - PERSONAL..::"
          worksheet="sheet1"
          name="personal.xls"
          :data="json_data"
          :fields="json_fields"
        >
          <i class="fa fa-file-excel"></i>
          Excel
        </export-excel>
      </div>
    </div>
    <!-- begin row -->
    <div class="row animated fadeIn" v-if="nuevoPersonal == 0">
      <!-- begin col-12 -->
      <div class="col-xl-12">
        <div class="p-2">
          <departamento
            v-show="nuevoPersonal == 0"
            :valor_entrada="depatamentoSeleccionado"
            @evento="
              depatamentoSeleccionado = $event;
              procesarBusquedaDepartamento();generarExcel =0
            "
            v-model="depatamentoSeleccionado"
          />
        </div>

        <registros
          v-if="!proceso"
          :departamento="depatamentoSeleccionado"
          :field="'idpersona'"
          :columns="columns2"
          @eliminar="confirmar($event)"
          @editar="
            nuevoPersonal = 1;
            personal = { ...$event };
            nuevo = false;
          "
          @adelanto_saldo="adelantar($event)"
          :url="this.URL_BASE() + 'personal/search/'"
        >
          <template v-slot:tipo="slotProps">
            {{
              slotProps.tipo.tipo == 2
                ? "ADM"
                : slotProps.tipo.tipo == 1
                ? "VENDEDOR"
                : slotProps.tipo.tipo == 3
                ? "RESPONSABLE FFVV"
                : slotProps.tipo.tipo == 4
                ? "RESPONSABLE PDV"
                : slotProps.tipo.tipo == 5
                ? "Responsable AACC"
                : slotProps.tipo.tipo == 6
                ? "Responsable VVMM"
                : "Responsable MMARCA"
            }}
          </template>
          <template v-slot:personal="slotProps">
            {{ slotProps.personal.appa + " " + slotProps.personal.apma }} <br />
            {{ slotProps.personal.nombres }}
          </template>
        </registros>
        <procesando v-if="proceso" />
      </div>
      <!-- end col-12 -->
    </div>
    <!-- end row -->
    <!-- begin row -->
    <div class="row animated fadeIn" v-if="nuevoPersonal == 1">
      <!-- begin col-12 -->
      <div class="col-xl-12">
        <personal
          v-show="!proceso"
          @cancelar="nuevoPersonal = 0"
          @actualizar="actualizar($event)"
          @guardar="guardar($event)"
          :registro="personal"
          :nuevo="nuevo"
        />
        <procesando v-show="proceso" />
      </div>
      <!-- end col-12 -->
    </div>
    <!-- end row -->
    <!-- #modal-dialog -->
    <b-modal
      ref="modalDialog"
      size="xl"
      id="modalDialog"
      cancel-variant="default"
      :title="
        'ADELANTO PARA EL VENDEDOR: ' +
        persona.nombres +
        ' ' +
        persona.apellidos
      "
    >
      <div class="row">
        <div class="col-xl-2 col-lg-2">
          <br />
          <div class="form-group">
            <input
              type="text"
              v-model="adelanto.monto"
              data-vv-name="monto"
              v-validate="'required'"
              placeholder="Ingrese el monto"
              class="form-control"
            />
            <error :attribute_name="'monto'" :errors_form="errors" />
          </div>
        </div>
        <div class="col-xl-4 col-lg-4">
          <div class="form-group">
            <textarea
              v-model="adelanto.motivo"
              data-vv-name="motivo"
              v-validate="'required'"
              class="form-control"
              placeholder="Ingrese el motivo"
            ></textarea>
            <error :attribute_name="'motivo'" :errors_form="errors" />
          </div>
        </div>
        <div class="col-xl-3 col-lg-3">
          <div class="form-group">
            <input
              type="date"
              class="form-control"
              placeholder="Ingrese fecha"
              v-model="adelanto.fecha_adelanto"
              data-vv-name="fecha_adelanto"
              v-validate="'required'"
            />
            <error :attribute_name="'fecha_adelanto'" :errors_form="errors" />
          </div>
        </div>
        <div class="col-xl-3 col-lg-3">
          <div class="form-group">
            <button
              v-if="nuevo_adelanto"
              @click="generarAdelanto()"
              type="button"
              class="btn btn-primary btn-lg btn-block"
            >
              <i class="fa fa-save"></i> Crear adelanto
            </button>
            <button
              v-if="!nuevo_adelanto"
              @click="modificarAdelanto()"
              type="button"
              class="btn btn-warning btn-lg btn-block"
            >
              <i class="fa fa-edit"></i> Actualizar
            </button>
            <button
              v-if="!nuevo_adelanto"
              @click="
                nuevo_adelanto = true;
                limpiarAdelanto();
              "
              type="button"
              class="btn btn-secondary btn-lg btn-block"
            >
              <i class="fa fa-edit"></i> Cancelar adelanto
            </button>
          </div>
        </div>
      </div>

      <hr />
      <h3 class="text-center">Detalle de Adelantos</h3>
      <table class="table table-hover">
        <thead>
          <tr>
            <th>#</th>
            <th>Monto S/.</th>
            <th>Motivo de Adelanto</th>
            <th>Fecha Adelanto</th>
            <th>Fecha Modificación</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tr v-for="(item, index) in adelantos" :key="item.Id">
          <td>{{ index + 1 }}</td>
          <td>{{ parseFloat(item.monto).toFixed(2) }}</td>
          <td>{{ item.motivo }}</td>
          <td>{{ item.fecha_adelanto }}</td>
          <td>{{ item.fecha_modificacion }}</td>
          <td>
            <button
              v-if="verificarAnioMesAdelanto(item.fecha_adelanto)"
              type="button"
              @click="
                adelanto = { ...item };
                nuevo_adelanto = false;
              "
              class="btn btn-info btn-sm"
            >
              <i class="fa fa-edit"></i> Modificar
            </button>
            &nbsp;
            <button
              v-if="verificarAnioMesAdelanto(item.fecha_adelanto)"
              type="button"
              @click="eliminarAdelanto(item.Id)"
              class="btn btn-danger btn-sm"
            >
              <i class="fa fa-trash"></i> Eliminar
            </button>
          </td>
        </tr>
      </table>
      <template #modal-footer>
        <b-button
          variant="secondary"
          size="sm"
          class="float-right"
          @click="
            $bvModal.hide('modalDialog');
            nuevo_adelanto = true;
            limpiarAdelanto();
          "
        >
          <i class="fa fa-times"></i> Cancelar
        </b-button>
      </template>
    </b-modal>
  </div>
</template>


<script>
import Vue from "vue";
import personal from "../components/compartidos/principales/Personal";
import registros from "../components/compartidos/Registros";
import procesando from "../components/compartidos/Procesando";
import error from "../components/compartidos/Error.vue";
import departamento from "../components/compartidos/SelectDepartamentos";
import axios from "axios";
import excel from "vue-excel-export";
Vue.use(excel);
export default {
  name: "Personal",
  components: {
    personal,
    registros,
    procesando,
    error,
    departamento,
  },
  created() {
    // this.loadItems() ;
  },
  data() {
    return {
      generarExcel: 0,
      json_fields: {
        Departamento: "departamento",
        "Apellido Paterno": "appa",
        "Apellido Materno": "apma",
        Nombres: "nombres",
        DNI: {
          field: "dni",
          callback: (value) => {
            return `DNI - ${value}`;
          },
        },
		Celular:"cel",
		Domicilio:"domicilio",
        "Tipo Personal": {
          field: "tipo",
          callback: (value) => {
            if (value == 2) return "ADM";
            if (value == 1) return "VENDEDOR";
            if (value == 3) return "RESPONSABLE FFVV";
            if (value == 4) return "RESPONSABLE PDV";
            if (value == 5) return "Responsable AACC";
            if (value == 6) return "Responsable VVMM";
            return "Responsable MMARCA";
          },
        },
        Equipo: "equipo",
        Observaciones: "observaciones",
      },
      json_data: [],
      depatamentoSeleccionado: "",
      proceso: false,
      nuevo: true,
      personal: null,
      nuevoPersonal: 0,
      counter: 0,
      forms: [],
      detalles: [],
      totalRecords: 0,
      persona: {
        apellidos: "",
        idpersona: "",
        nombres: "",
        dni: "",
      },
      nuevo_adelanto: true,
      adelantos: [],
      adelanto: {
        Id: "",
        dni_vendedor: "",
        monto: "",
        motivo: "",
        fecha_modificacion: "",
        fecha_adelanto: "",
        estado: "",
      },
      serverParams: {
        search: "",
        sort: {
          field: "idpersona",
          type: "asc",
        },
        page: 1,
        perPage: 10,
      },
      columns2: [
        {
          label: "Departamento",
          field: "departamento",
          width: "10%",
          thClass: "text-nowrap",
          tdClass: "text-nowrap",
        },
        {
          label: "Personal",
          field: "personal",
          width: "13%",
          thClass: "text-nowrap",
          tdClass: "text-nowrap",
        },

        {
          label: "DNI",
          field: "dni",
          width: "5%",
          tdClass: "text-center ",
          thClass: "text-center ",
        },
        {
          label: "Celular",
          field: "cel",
          width: "10%",
          tdClass: "text-center ",
          thClass: "text-center ",
        },
        {
          label: "Domicilio",
          field: "domicilio",
          width: "15%",
          tdClass: "text-nowrap ",
          thClass: "text-nowrap ",
        },
        {
          label: "Correo",
          field: "email",
          width: "15%",
          tdClass: "text-center ",
          thClass: "text-center ",
        },
        {
          label: "Tipo Vendedor",
          field: "tipo_vendedor",
          width: "10%",
          tdClass: "text-center ",
          thClass: "text-center ",
        },
        {
          label: "Cargo",
          field: "tipo",
          width: "10%",
          tdClass: "text-center ",
          thClass: "text-center ",
        },
        {
          label: "Clave",
          field: "clave",
          width: "8%",
          tdClass: "text-center ",
          thClass: "text-center ",
        },
        {
          label: "Equipo",
          field: "equipo",
          width: "8%",
          tdClass: "text-center ",
          thClass: "text-center ",
        },
        {
          label: "Observaciones",
          field: "observaciones",
          width: "8%",
          tdClass: "text-center ",
          thClass: "text-center ",
        },
        {
          label: "Adelantos",
          field: "clave",
          width: "10%",
          tdClass: "text-center ",
          thClass: "text-center ",
        },
      ],
    };
  },
  methods: {
    descargarExcel() {
      this.generarExcel = 1;
      axios
        .post(this.URL_BASE() + "personal/excel/", {
          departamento: this.depatamentoSeleccionado,
          search: "",
        })
        .then((respuesta) => {
          console.log(respuesta.data.msg);
          if (respuesta.data.msg == "exito") {
            this.json_data = respuesta.data.data;
            this.generarExcel = 2;
          } else {
            this.generarExcel = 0;
          }
        })
        .catch((error) => {
          this.generarExcel = 0;
          console.log("er store" + error);
        });
    },
    actualizar(registro) {
      this.proceso = true;
      axios
        .put(this.URL_BASE() + "personal/update/", registro)
        .then((respuesta) => {
          //   console.log(respuesta.data.msg)
          if (respuesta.data.msg == "exito") {
            this.exito("Personal registrado correctamente");
          }
          this.proceso = false;
        })
        .catch((error) => {
          console.log("er store" + error);
        });
    },
    guardar(registro) {
      this.proceso = true;
      axios
        .post(this.URL_BASE() + "personal/create/", registro)
        .then((respuesta) => {
          //   console.log(respuesta.data.msg)
          if (respuesta.data.msg == "exito") {
            this.exito("Personal actualizado correctamente");
          }
          this.proceso = false;
        })
        .catch((error) => {
          console.log("er store" + error);
        });
    },
    confirmar(registros) {
      // let a = await this.confirmar();
      this.$swal({
        title: "¿Estás seguro?",
        text: "¡Los registros seleccionados se eliminarán!",
        type: "warning",
        showCancelButton: true,
        buttonsStyling: false,
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        confirmButtonClass: "btn m-r-5 btn-warning",
        cancelButtonClass: "btn btn-default",
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.value) {
          this.eliminar(registros);
          // this.$swal('Proceso confirmado', '', 'success')
          return true;
        } else if (result.dismiss) {
          return false;
          // Swal.fire('Changes are not saved', '', 'info')
        }
      });
    },
    eliminar(registros) {
      this.proceso = true;
      axios
        .post(this.URL_BASE() + "personal/delete", registros)
        .then((respuesta) => {
          if (respuesta.data.msg == "exito") {
            this.$swal("Proceso completado", "", "success");
          }
          this.proceso = false;
        })
        .catch((error) => {
          console.log("er store" + error);
        });
    },
    generarAdelanto() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.proceso = true;
          this.adelanto.dni_vendedor = this.persona.dni;
          axios
            .post(this.URL_BASE() + "adelantos/create", this.adelanto)
            .then((respuesta) => {
              if (respuesta.data.msg == "exito") {
                this.$swal("Proceso completado", "", "success");
                this.adelantos = [...respuesta.data.dataAdicional];
              }
              this.proceso = false;
              this.limpiarAdelanto();
            })
            .catch((error) => {
              console.log("er store" + error);
            });
          return;
        }
      });
    },
    modificarAdelanto() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.proceso = true;
          this.adelanto.dni_vendedor = this.persona.dni;
          axios
            .post(this.URL_BASE() + "adelantos/update", this.adelanto)
            .then((respuesta) => {
              if (respuesta.data.msg == "exito") {
                this.$swal("Proceso completado", "", "success");
                this.adelantos = [...respuesta.data.dataAdicional];
                this.nuevo_adelanto = true;
              }
              this.proceso = false;
              this.limpiarAdelanto();
            })
            .catch((error) => {
              console.log("er store" + error);
            });
          return;
        }
      });
    },
    procesarBusquedaDepartamento() {
      this.proceso = true;
      setTimeout(() => {
        this.proceso = false;
      }, 2000);
    },
    eliminarAdelanto(id) {
      this.$swal({
        title: "¿Estás seguro?",
        text: "¡Este adelanto se eliminará!",
        type: "warning",
        showCancelButton: true,
        buttonsStyling: false,
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        confirmButtonClass: "btn m-r-5 btn-warning",
        cancelButtonClass: "btn btn-default",
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.value) {
          this.adelanto.estado = 0;
          this.proceso = true;
          this.adelanto.dni_vendedor = this.persona.dni;
          this.adelanto.Id = id;
          axios
            .post(this.URL_BASE() + "adelantos/update", this.adelanto)
            .then((respuesta) => {
              if (respuesta.data.msg == "exito") {
                this.$swal("Proceso completado", "", "success");
                this.adelantos = [...respuesta.data.dataAdicional];
                this.nuevo_adelanto = true;
              }
              this.proceso = false;
              this.limpiarAdelanto();
            })
            .catch((error) => {
              console.log("er store" + error);
            });
          return true;
        } else if (result.dismiss) {
          return false;
        }
      });
    },
    verAdelanto(dni) {
      axios
        .post(this.URL_BASE() + "adelantos/read/" + dni)
        .then((respuesta) => {
          if (respuesta.data.msg == "exito") {
            this.adelantos = [...respuesta.data.data];
          }
        })
        .catch((error) => {
          console.log("er store" + error);
        });
    },

    adelantar(registro) {
      this.adelantos = [];
      this.$bvModal.show("modalDialog");
      this.persona = {
        ...registro,
      };
      this.verAdelanto(this.persona.dni);
    },
    limpiarAdelanto() {
      (this.adelanto.Id = ""),
        (this.adelanto.dni_vendedor = ""),
        (this.adelanto.monto = "");
      this.adelanto.motivo = "";
      this.adelanto.fecha_modificacion = "";
      this.adelanto.fecha_adelanto = "";
      this.adelanto.estado = "";
    },
    verificarAnioMesAdelanto(fecha) {
      var fecha_adelanto = new Date(fecha);
      var anio0 = fecha_adelanto.getFullYear();
      let mes0 = fecha_adelanto.getMonth() + 1;

      var hoy = new Date();
      var anio = hoy.getFullYear();
      let mes = hoy.getMonth() + 1;

      if (anio0 + "-" + mes0 == anio + "-" + mes) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>